import { render, staticRenderFns } from "./codeEdit.vue?vue&type=template&id=1d24d7ae&scoped=true&"
import script from "./codeEdit.vue?vue&type=script&lang=js&"
export * from "./codeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d24d7ae",
  null
  
)

export default component.exports